var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showEdit
        ? [
            _c("div", { staticClass: "row mb-4 pl-3" }, [
              _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("validation-provider", {
                    attrs: { name: "Teléfono", rules: "required|length:11" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  "custom-error-msg": "Campo Requerido",
                                  error: errors[0],
                                  label: "Teléfono:",
                                  "mask-type": "Phone",
                                  placeholder: "(___) ___-____"
                                },
                                model: {
                                  value: _vm.model.locationTelephoneNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "locationTelephoneNo",
                                      $$v
                                    )
                                  },
                                  expression: "model.locationTelephoneNo"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2237919540
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("custom-input", {
                    attrs: {
                      label: "Fax:",
                      "mask-type": "Phone",
                      placeholder: "(___) ___-____"
                    },
                    model: {
                      value: _vm.model.locationTelephoneFaxNo,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "locationTelephoneFaxNo", $$v)
                      },
                      expression: "model.locationTelephoneFaxNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("custom-input", {
                    attrs: {
                      label: "Dirección Web:",
                      placeholder: "www.websitedomain.com"
                    },
                    model: {
                      value: _vm.model.locationWebsiteUrl,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "locationWebsiteUrl", $$v)
                      },
                      expression: "model.locationWebsiteUrl"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm d-flex align-items-end" },
                [_vm._t("default")],
                2
              )
            ])
          ]
        : [
            _c("div", { staticClass: "row mb-4 pl-3" }, [
              _c(
                "div",
                { staticClass: "col-4 my-2" },
                [
                  _c("custom-input-display", {
                    attrs: {
                      label: "Teléfono:",
                      "mask-type": "Phone",
                      placeholder: "(___) ___-____"
                    },
                    model: {
                      value: _vm.model.locationTelephoneNo,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "locationTelephoneNo", $$v)
                      },
                      expression: "model.locationTelephoneNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4 my-2" },
                [
                  _c("custom-input-display", {
                    attrs: {
                      label: "Fax:",
                      "mask-type": "Phone",
                      placeholder: "(___) ___-____"
                    },
                    model: {
                      value: _vm.model.locationTelephoneFaxNo,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "locationTelephoneFaxNo", $$v)
                      },
                      expression: "model.locationTelephoneFaxNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4 my-2" },
                [
                  _c("custom-input-display", {
                    attrs: { label: "Dirección Web:" },
                    model: {
                      value: _vm.model.locationWebsiteUrl,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "locationWebsiteUrl", $$v)
                      },
                      expression: "model.locationWebsiteUrl"
                    }
                  })
                ],
                1
              )
            ]),
            _vm.isMedicaidDocumentationWorkflowEnabled
              ? _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-3 my-2" },
                    [
                      _vm.showSchoolSection
                        ? _c("custom-input-display", {
                            attrs: {
                              label: "NPI LS DEPR:",
                              value: _vm.model.locationSchoolNationalIdentifier
                            }
                          })
                        : _c("custom-input", {
                            attrs: {
                              disabled: _vm.isNpiDisabled,
                              label: "NPI LS DEPR:",
                              placeholder: "Ingrese el NPI LS DEPR"
                            },
                            model: {
                              value: _vm.model.locationSchoolNationalIdentifier,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "locationSchoolNationalIdentifier",
                                  $$v
                                )
                              },
                              expression:
                                "model.locationSchoolNationalIdentifier"
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-3 my-2" },
                    [
                      _c("custom-input", {
                        attrs: {
                          disabled: _vm.isNpiDisabled,
                          label: "NPI LS Proveedor:",
                          placeholder: "Ingrese el NPI LS Proveedor"
                        },
                        model: {
                          value: _vm.model.nationalIdentifier,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "nationalIdentifier", $$v)
                          },
                          expression: "model.nationalIdentifier"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-2 my-2" },
                    [
                      _c("custom-input", {
                        attrs: {
                          disabled: _vm.isNpiDisabled,
                          label: "Medicaid ID:",
                          maxlength: "50",
                          placeholder: "Ingrese el Medicaid ID"
                        },
                        model: {
                          value: _vm.model.medicalIdentifier,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "medicalIdentifier", $$v)
                          },
                          expression: "model.medicalIdentifier"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "row col-sm-4 my-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("custom-date-picker", {
                          attrs: {
                            "class-container": "w-100",
                            disabled: _vm.isNpiDisabled,
                            format: "dd/MMM./yyyy",
                            label: "Fecha de Vencimiento Medicaid:",
                            "min-date": _vm.currentDate,
                            plcaeholder:
                              "Seleccione la fecha de vencimiento del Medicaid"
                          },
                          model: {
                            value: _vm.model.medicaidDueDate,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "medicaidDueDate", $$v)
                            },
                            expression: "model.medicaidDueDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex",
                        class: { "ml-3": !_vm.isNpiDisabled }
                      },
                      [
                        _c("div", { staticClass: "mt-4" }, [
                          _vm.editingNpi
                            ? _c("div", [
                                _vm.canCancelNpi && _vm.initialNpi
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "ab-btn ab-btn-outline-danger mt-1 mr-2",
                                        attrs: {
                                          type: "button",
                                          variant: "outline-danger mt-1 mr-2"
                                        },
                                        on: { click: _vm.cancelEditNpi }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-times-circle"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "button",
                                  {
                                    staticClass: "ab-btn ab-btn-success mt-1",
                                    attrs: { type: "button" },
                                    on: { click: _vm.saveNpi }
                                  },
                                  [_c("i", { staticClass: "fas fa-save" })]
                                )
                              ])
                            : _c(
                                "button",
                                {
                                  staticClass: "ab-btn ab-btn-success mt-1",
                                  attrs: { type: "button" },
                                  on: { click: _vm.editNpi }
                                },
                                [_c("i", { staticClass: "fas fa-edit" })]
                              )
                        ])
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }